const GROUPS = {
  // Root Group > Secondary Group > Group 4 > Site
  GROUP_PATH_DELIMITER: " > "
};

export default GROUPS;